const all = '全部'
const userTypes = {
  all,
  student: '警员',
  // teacher: '教师',
  others: '其他'
}
const bindStates = {
  all,
  bound: '已激活',
  unbind: '未绑定',
  lost: '已挂失'
  // bound: '已绑定',
  // unbind: '未绑定',
  // applied: '已申请',
  // inMaking: '制卡中',
  // tobeActivated: '待激活',
  // activated: '已激活'
}
const roleTypes = {
  admin: '管理员',
  teacher: '员工',
  'org-admin': '管理员',
  'org-super-admin': '超级管理员'
}
const enableTypes = {
  all,
  enable: '启用',
  disable: '禁用'
}
// const schoolTypes = {
//   primary: '小学',
//   middle: '初中',
//   hight: '高中'
// }

export {
  all,
  userTypes,
  bindStates,
  roleTypes,
  enableTypes
  // schoolTypes
}
